export default "__VITE_ASSET__C5DFE4TA__"